<template>
    <el-form :label-position="labelPosition" :inline="true" :model="formInline">
        <el-scrollbar height="380px" v-if="vertical">
            <el-form-item label-width="80px" v-for="(item,index) in filters" 
                :key="index" 
                :label="displayName(item.field)"
                v-show="showFilterItem(index)">
                <component
                    :is="item.fieldType  + 'Filter'"
                    :filterItem = "item"
                    :contentDefinition="contentDefinition(item.field)">
                </component>
            </el-form-item>
        </el-scrollbar>
        <template v-else>
            <el-form-item label-width="80px" v-for="(item,index) in filters" 
                :key="index" 
                :label="displayName(item.field)"
                v-show="showFilterItem(index)">
                <component
                    :is="item.fieldType  + 'Filter'"
                    :filterItem = "item"
                    :contentDefinition="contentDefinition(item.field)">
                </component>
            </el-form-item>
        </template>
        <el-form-item>
            <el-button @click="queryFilter" type="primary"> <el-icon><search /></el-icon> 查询</el-button> 
            <el-button @click="resetFilter"> <el-icon><refreshRight /></el-icon> 重置</el-button>
            <span v-if="this.filters.length > 2">
                <el-button link type="primary" v-show="showTwo" @click="toggleState">展开 <el-icon><arrowDownBold /></el-icon></el-button>
                <el-button link type="primary" v-show="!showTwo" @click="toggleState">折叠 <el-icon><arrowUp /></el-icon></el-button>
            </span>
        </el-form-item>
    </el-form>
</template>

<style>
    .query{
        display: flex;
        flex-wrap: wrap;
    }
</style>

<script>
    import { getFieldDefinition } from "@/apis/httpHelper"; 
    import { FilterNullRule,FilterConfig } from "../index";
    import { Search, RefreshRight, ArrowUpBold, ArrowDownBold } from "@element-plus/icons-vue"


    export default{
        name:"SimpleFilter",
        props:{
            vertical:{
                type: Boolean,
                default:function(){
                    return false
                }
            },

            contentType:{
                type: String,
            },

            filterOperatorConfig:{
                type:Object,
                default:function(){
                    return {}
                }
            },

            fields:{
                type: Array
            },

            fieldDefinitions:{
                type: Array
            }
        },

        emits:[
            "success",
            "resetfilter"
        ],

        provide:function(){
            return {
                contentType:this.contentType,
                buildFormContext:this.buildFormContext
            }
        },

        components:{
            "search":Search,
            "refreshRight":RefreshRight,
            "arrowUp":ArrowUpBold,
            "arrowDownBold":ArrowDownBold
        },  

        data:function(){
            return {
                supportSelectedFields:[],
                logic:"and",
                filters:[],
                formInline:{},
                showTwo:true,
                formContext:{}
            }
        },

        computed:{
            labelPosition:function(){
                return this.vertical ? "top" : "right"
            },
        },

        created:function(){
            if((this.fieldDefinitions || []).length > 0){
                let result = this.fieldDefinitions.map(x=>{
                    let text = this.filterOperatorConfig[x.Name]?.displayName || x.Settings.ContentPartFieldSettings.DisplayName;
                    let value = x.Name;
                    return {
                        operator: this.filterOperatorConfig[x.Name]?.operator || FilterConfig[x.FieldDefinition.Name].defaulOperator,
                        text: text,
                        value: value,
                        fieldType: x.FieldDefinition.Name,
                        definition:x
                    }
                });
                
                this.supportSelectedFields = result;
                this.initFilters(); 
            }
            else{
                getFieldDefinition(this.contentType,this.fields)
                .then(x=>{
                    let result = x.Result.map(x=>{
                        let text = this.filterOperatorConfig[x.Name]?.displayName || x.Settings.ContentPartFieldSettings.DisplayName;
                        let value = x.Name;
                        return {
                            operator: this.filterOperatorConfig[x.Name]?.operator || FilterConfig[x.FieldDefinition.Name].defaulOperator,
                            text: text,
                            value: value,
                            fieldType: x.FieldDefinition.Name,
                            definition:x
                        }
                    });
                    this.supportSelectedFields = result;
                    this.initFilters(); 
                }).catch(x=>{
                    console.log(x)
                })
            } 
            
            getFieldDefinition(this.contentType).then(x=>{
                let fields = x.Result;
                fields.forEach(field => this.formContext[field.Name] = null);
            })   
        },
        methods:{
            buildFormContext:function(){
                return { 
                    Content:this.formContext,
                    UserInfo:this.$store.state.userInfo,
                    Properties:{
                        Env:"Filter"   
                    }
                }; 
            },


            displayName:function(value){
                return (this.supportSelectedFields.find(x=> x.value == value) || {"text":{}}).text;
            },

            contentDefinition:function(value){
                return (this.supportSelectedFields.find(x=> x.value == value) || {"definition":{}}).definition;
            },

            showFilterItem:function(index){
                if(this.showTwo & index > 1){
                    return false;
                }
                else{
                    return true;
                }
            },

            toggleState:function(){
                this.showTwo = !this.showTwo
            },  

            initFilters:function(){
                this.filters = this.supportSelectedFields.map(x=>{
                    return {
                        "fieldType":x.fieldType,
                        "field":x.value,
                        "operator": x.operator,
                        "value":[]
                    }
                });
                if(this.filters.length > 2){

                }
            },
            
            resetFilter:function(){
                this.filters.forEach(x=>{
                    x.value = [];
                });
                this.$emit("resetfilter");
            },

            queryFilter:function(){
                let filters = (this.filters||[]).map(x=>{
                    if(!this.checkFilter(x)){
                        return null;
                    }
                    else{
                        let data = {
                            field: x.field,
                            operator: x.operator,
                            value: x.value
                        }
                        return FilterConfig[x.fieldType].buildFilter(data);
                    }
                });
                if(filters.filter(x=> x != null).length > 0){
                    this.$emit("success", { "logic":this.logic,"filters":filters.filter(x=> x != null) });
                }
            },
            
            checkFilter:function(filter){
                if(!FilterNullRule.includes(filter.operator)){
                    if(filter.value.length > 0){
                        return true;
                    }
                    else{
                        return false;
                    }
                }
            }
        } 
    }
</script>